namespace TabAurous.Administration {
    export interface QualityInspectionTemplateRow {
        TemplateId?: number;
        Code?: string;
        Details?: QualityInspectionTemplateDetailsRow[];
    }

    export namespace QualityInspectionTemplateRow {
        export const idProperty = 'TemplateId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'Administration.QualityInspectionTemplate';
        export const lookupKey = 'Administration.QualityInspectionTemplate';

        export function getLookup(): Q.Lookup<QualityInspectionTemplateRow> {
            return Q.getLookup<QualityInspectionTemplateRow>('Administration.QualityInspectionTemplate');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            TemplateId = "TemplateId",
            Code = "Code",
            Details = "Details"
        }
    }
}
